var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "850.39px",
    height: "850.39px",
    viewBox: "0 0 850.39 850.39",
    enableBackground: "new 0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.407,348.901c0,20.398-16.534,36.935-36.938,36.935c-20.398,0-36.937-16.537-36.937-36.935 c0-20.401,16.539-36.938,36.937-36.938C451.873,311.963,468.407,328.5,468.407,348.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.407,551.786c0,13.464-14.827,24.387-33.128,24.387h-11.96c-18.297,0-33.131-10.923-33.131-24.387V416.31 c0-13.47,14.834-24.388,33.131-24.388h11.96c18.301,0,33.128,10.918,33.128,24.388V551.786z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.826,
    y: 558.11,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 554.1035 -209.3174)",
    width: 243.787,
    height: 12.182
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "532.26,734.033 452.909,654.683 532.26,575.333  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "532.246,575.342 611.603,654.687 532.258,734.042  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "leftHand",
    d: "M438.419,476.666c-5.768,5.769-15.123,5.769-20.89,0.001l-46.707-46.708 c-5.771-5.771-5.772-15.125-0.002-20.893l0,0c5.77-5.77,15.125-5.773,20.896-0.002l46.706,46.706 C444.191,461.539,444.189,470.896,438.419,476.666L438.419,476.666z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.032,
    y: 560.474,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 972.374 730.3584)",
    width: 243.786,
    height: 12.181
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "332.384,736.398 411.733,657.049 332.384,577.698  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "332.396,577.708 253.041,657.052 332.385,736.408  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "rightHand",
    d: "M495.722,409.066c5.77,5.766,5.768,15.123,0,20.893l-46.704,46.705c-5.775,5.773-15.131,5.773-20.898,0.006 l0,0c-5.773-5.773-5.771-15.127,0.003-20.902l46.703-46.703C480.596,403.295,489.949,403.293,495.722,409.066L495.722,409.066z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.4cf8c9e1bc0c42ba892c4a40c3669dcf.svg";
export { ForwardRef as ReactComponent };